var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kendo-hierarchicaldatasource',{ref:'tagDataSourceRef',attrs:{"data":_vm.tagsData.data,"schema":_vm.tagsData.schema}}),_c('kendo-dropdowntree',{attrs:{"data-source-ref":'tagDataSourceRef',"data-text-field":'tag',"data-value-field":'tag',"checkboxes-check-children":true,"check-all":_vm.checkAll,"tag-mode":'multiple'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }